/**
 * Import styles
 */
import '../css/base.scss';

/**
 * Import vendor scripts.
 */
import objectFitImages from 'object-fit-images';
import 'lazysizes';
import 'picturefill';

/**
 * Import own scripts.
 */
import './Nav-Toggle-Component.js';
import './Navigation-Component.js';
import './Hero-Component.js';

document.addEventListener('DOMContentLoaded', function () {
  /**
	 * Add support for object-fit and object-position to legacy browsers.
	 */
  objectFitImages();
});
